<template>
  <v-app>
    <v-app-bar dark elevation="1" app absolute class="light-blue darken-3">
      <v-toolbar-title justify="center">
        <v-icon class="mr-2" x-large> mdi-store </v-icon>
        DAV - Backoffice
      </v-toolbar-title>
      <v-col v-if="!loggedIn" class="text-right">
        <v-btn elevation="0" @click="openLoginDialog">
          <v-icon medium> mdi-account </v-icon>
          Login Admin</v-btn
        >
      </v-col>
      <v-col v-else class="text-right">
        <v-btn elevation="0" @click="signOut">
          <v-icon medium> mdi-door </v-icon>
          Logout</v-btn
        >
      </v-col>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main v-if="loggedIn">
      <template>
        <v-card-title class="justify-center "
          ><v-alert
            :value="alert"
            transition="scale-transition"
            prominent
            dismissible
            text
            :type="success"
          >
            Action successful. <br />
            The first request may take a minute to boot up the machine.</v-alert
          >
          <!-- <v-alert
            prominent
            dismissible
            text
            type="error"
            transition="scale-transition"
          >
            Action failed. Please try again.</v-alert
          > -->
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="userData"
          :search="search"
          sort-by="surname"
          item-key="name"
          class="elevation-4"
          :loading="isLoading"
        >
          <!-- Top  and Title of Data Table -->
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Members</v-toolbar-title>

              <v-divider class="mx-4" inset vertical></v-divider>
              <v-btn color="primary" @click="initialize">Refresh</v-btn>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>

              <v-spacer></v-spacer>

              <!-- ADD USER DIALOG  -->
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                    >Add User</v-btn
                  >
                </template>

                <v-card>
                  <!-- MODAL EDIT ITEM -->
                  <v-card-title>
                    <span class="headline"> {{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.name"
                            label="Name"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.surname"
                            label="Surname"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.birthday"
                            label="Birthday"
                            v-mask="'##.##.####'"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.title"
                            label="Title"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.cardId"
                            label="CardId"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.home"
                            label="Home"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.section"
                            label="Section"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.sports"
                            label="Sports"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          ><input
                            type="file"
                            @change="previewImage"
                            accept="image/*"
                            class="imgUpload"
                          />
                          <v-col>
                            <v-img
                              class="imgPreview"
                              :src="editedItem.bytes"
                              v-if="editedItem.bytes"
                            ></v-img>
                          </v-col>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <!-- MODAL EDIT  ACTION -->
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="updateUser"
                      :loading="isSaving"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- DELETE DIALOG  -->
              <v-dialog v-model="dialog2" max-width="500px">
                <v-card>
                  <v-card-title>
                    <span class="headline"> Delete </span>
                  </v-card-title>
                  <v-card-text>
                    Are you sure you want to delete the user
                    {{ deletedItem.name }} {{ deletedItem.surname }}
                  </v-card-text>
                  <!-- DELETE ACTIONS -->
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      :loading="isSaving"
                      @click="deleteUser"
                      >DELETE</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- dialogEND -->
            </v-toolbar>
          </template>

          <!-- Table modifier on Slots -->
          <template v-slot:[`item.cardId`]="{ item }">
            <v-chip :color="getColor(item.cardId)" dark>{{
              item.cardId
            }}</v-chip>
          </template>
          <template v-slot:[`item.bytes`]="{ item }">
            <img
              @click="goToUserCard(item)"
              class="image-head"
              :src="item.bytes"
            />
          </template>

          //actions
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2" @click="editItem(item)" v-on="on">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon small @click="confirmDelete(item)" v-on="on">
                  mdi-delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </template>
          //reset
        </v-data-table>
      </template>

      <!-- Provides the application the proper gutter -->
      <!-- <v-container fluid>
         If using vue-router 
          <router-view></router-view>
        </v-container> -->
      <!-- <LoggedStatus /> -->
    </v-main>
    <v-main v-else>
      <template>
        <v-card-title class="justify-center"> <p class="text-center">
          Please Login
        </p></v-card-title>
       
        <v-card-title class="justify-center">
          <v-img
            lazy-src="@/assets/lock.jpg"
            max-height="150"
            max-width="250"
            src="@/assets/lock.jpg"
          ></v-img
        ></v-card-title>
      </template>
      <!-- LOGIN DIALOG -->
      <v-dialog v-model="loginDialog" max-width="300px">
        <v-card>
          <v-card-title>
            <span class="headline"> Admin Login </span>
          </v-card-title>
          <v-card-text>
            <v-col>
              <v-text-field
                v-model="loginAdminUser.user"
                label="Login"
              ></v-text-field>
              <v-text-field
                v-model="loginAdminUser.password"
                label="Password"
                type="password"
              ></v-text-field>
              <v-alert v-if="loginError === true" dense outlined type="error">
                Incorrect login data
              </v-alert>
            </v-col>
          </v-card-text>
          <!-- LOGIN ACTIONS -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              text
              :loading="isSaving"
              @click="loginAdmin"
              >LOGIN</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog></v-main
    >
    <!-- <v-footer app>
           </v-footer> -->
  </v-app>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/auth';
import { values } from 'lodash';

export default {
  name: 'Backoffice',
  title: 'Backoffice',
  components: {},
  data() {
    return {
      currentValue: '',
      users: '',
      isLoading: true,
      isSaving: false,
      search: '',
      alert: false,
      alertType: 'success',
      //data table
      dialog: false,
      dialog2: false,
      headers: [
        { text: 'Image', value: 'bytes' },
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },

        { text: 'Surname', value: 'surname' },
        { text: 'Birthday', value: 'birthday' },
        { text: 'Title', value: 'title' },
        { text: 'CardId', value: 'cardId' },
        { text: 'Home', value: 'home' },
        { text: 'Section', value: 'section' },
        { text: 'Sports', value: 'sports' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      userData: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        surname: '',
        birthday: '',
        title: '',
        sports: '',
        home: '',
        section: '',
        cardId: '',
        bytes: '',
        hash: '',
      },
      defaultItem: {
        name: '',
        surname: '',
        birthday: '',
        title: '',
        sports: '',
        home: '',
        section: '',
        cardId: '',
        bytes: '',
        hash: '',
      },
      deletedItem: '',
      imageData: '',
      loginDialog: false,
      loginAdminUser: {
        user: '',
        password: '',
      },
      loggedIn: '',
      loginError: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add User' : 'Edit User';
    },
    success() {
      return this.alertType;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  async created() {
    this.initialize();
    await firebase.auth().onAuthStateChanged((user) => {
      this.loggedIn = !!user;
    });
  },
  methods: {
    //Data Table - Initialize
    async initialize() {
      this.isLoading = true;
      this.userData = [];
      const getUsers = firebase.functions().httpsCallable('getUsers');
      await getUsers({ text: 'message' })
        .then((res) => (this.userData = values(res.data.users)))
        .then(() => (this.isLoading = false));
    },

    // MODAL DIALOG OPENING ACTIONS
    editItem(item) {
      this.editedIndex = this.userData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    confirmDelete(item) {
      this.deletedIndex = this.userData.indexOf(item);
      this.deletedItem = Object.assign({}, item);
      this.dialog2 = true;
    },

    close() {
      this.dialog = false;
      this.dialog2 = false;
      this.loginDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    setAlertType(type) {
      console.log(type);
      this.alertType = type;
      this.alert = true;
    },
    goToUserCard(item) {
      this.cardHashIndex = this.userData.indexOf(item);
      this.cardHashItem = Object.assign({}, item);
      console.log(this.cardHashItem.hash);
      // const local = 'http://localhost:8080/'
      const prod = 'https://kader.sportklettern.nrw/';
      window.open(prod + this.cardHashItem.hash, '_blank');
    },

    // CRUD FUNCTIONS

    // UPDATE OR ADD USER
    updateUser() {
      try {
        const updateUser = firebase.functions().httpsCallable('updateUser');
        const addUser = firebase.functions().httpsCallable('addUser');
        this.isLoading = true;
        this.isSaving = true;

        if (this.editedIndex > -1) {
          console.log(this.editedItem.hash);
          updateUser(this.editedItem)
            .then((updated) => {
              console.log(updated);
              Object.assign(this.userData[this.editedIndex], this.editedItem);
              this.close();
              this.isSaving = false;
              this.isLoading = false;
              this.setAlertType('success');
              console.log('successfully updated!');
              console.log(this.editedItem);
            })
            .catch(() => this.setAlertType('error'));
        } else {
          // ADD NEW USER FUNCTION
          console.log('creating...');
          console.log(this.editedItem);
          addUser(this.editedItem)
            .then((result) => {
              this.userData.push(this.editedItem);
              this.close();
              this.isSaving = false;
              this.isLoading = false;
              this.setAlertType('success');

              this.initialize();
            })
            .catch(() => {
              this.setAlertType('error');
            });
        }
      } catch (error) {
        console.log('Something went wrong, please try again');
      }
    },
    async deleteUser(item) {
      try {
        console.log('start deleting');
        const deleteUser = await firebase
          .functions()
          .httpsCallable('deleteUser');

        this.isLoading = true;
        this.isSaving = true;
        deleteUser(this.deletedItem)
          .then((deleted) => {
            this.userData.splice(this.deletedIndex, 1);
            this.isSaving = false;
            this.isLoading = false;
            console.log('successfully deleted!');
            this.close();
          })
          .catch(() => console.error());
      } catch (error) {
        console.log(error);
      }
    },

    getColor(CardId) {
      if (CardId) return 'green';
      else return 'red';
    },
    // Image Upload Event Listener
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Check Filesize
      const filesize = input.files[0].size / 1024 / 1024;
      //console.log(filesize.toFixed(4));
      // Ensure that you have a file before attempting to read it
      if (input.files[0] && filesize < 0.7) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
          this.editedItem.bytes = e.target.result;
          //.split(",").pop();
          console.log(this.bytes);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      } else {
        alert('File too big' + filesize);
      }
    },

    openLoginDialog() {
      this.loginDialog = true;
      this.loginError = false;
    },

    async loginAdmin() {
      try {
        this.loginError = false;
        this.isSaving = true;
        await firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        const val = await firebase
          .auth()
          .signInWithEmailAndPassword(
            this.loginAdminUser.user,
            this.loginAdminUser.password
          );
        this.isSaving = false;
        this.loginDialog = false;
        this.initialize();
      } catch (err) {
        this.loginError = true;
        this.isSaving = false;
        console.log(err);
      }
    },

    async signOut() {
      try {
        const signOut = await firebase.auth().signOut();
        this.initialize();
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image-head {
  width: 40px;
  cursor: pointer;
}
button:focus {
  outline: none;
}
* {
  font-family: roboto;
}
</style>

<style lang="scss">
html {
  overflow-y: auto !important;
}

.imgPreview {
  margin-top: 20px;
  width: 150px;
  height: 150px;
  left: -12px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.imgUpload {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
